// src/api/healthcare/hiServiceStatusApi.ts
// CU-14ygtkj8z2z: HEALTHCARE is authoritative for the HI provider mode; only the two exact tuples below are recognised.
// `VITE_HEALTHCARE_SERVER` already ends in `/api`.

import { ENV } from "../../config/runtimeEnv";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;

export const HI_SERVICE_MOCK_NOTICE =
	"HI SERVICE MOCK MODE - Synthetic response only. No request has been sent to the HI Service.";
export const HI_SERVICE_UNAVAILABLE_NOTICE =
	"HI SERVICE STATUS UNAVAILABLE - Live HI Service operation has not been confirmed.";
export const HI_SERVICE_CHECKING_NOTICE =
	"HI SERVICE STATUS CHECKING - Live HI Service operation has not been confirmed.";

export const HI_SERVICE_STATUS_QUERY_KEY = ["hi-service-status"] as const;

// CU-14ygtkj8z2z: "unrecognised" covers every body outside the two tuples; no mode ever means live.
export type HiServiceMode = "mock" | "unavailable" | "unrecognised";

export interface HiServiceStatus {
	mode: HiServiceMode;
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === "object" && value !== null && !Array.isArray(value);

const matchesTuple = (raw: Record<string, unknown>, provider: string, synthetic: boolean, notice: string): boolean =>
	raw.provider === provider && raw.is_live === false && raw.synthetic === synthetic && raw.non_live_notice === notice;

export const normaliseHiServiceStatus = (raw: unknown): HiServiceStatus => {
	if (!isRecord(raw)) return { mode: "unrecognised" };
	if (matchesTuple(raw, "mock", true, HI_SERVICE_MOCK_NOTICE)) return { mode: "mock" };
	if (matchesTuple(raw, "unavailable", false, HI_SERVICE_UNAVAILABLE_NOTICE)) return { mode: "unavailable" };
	return { mode: "unrecognised" };
};

// CU-14ygtkj8z2z: reduced to a mode so no backend text reaches a surface; a request failure propagates to React Query.
export const fetchHiServiceStatus = async (): Promise<HiServiceStatus> => {
	const response = await http.get(`${API_BASE_URL}/hi/service-status`);
	return normaliseHiServiceStatus(response.data);
};
